import PageDescription from "../../pages/admin/DataAnalyst/sections/PageDescription"
import DistributionIcon from '../../assets/images/icons/distribution.svg';
import Dialog from "../Dialogbox"
import { Link } from "react-router-dom"
import { ArtistInviteForm } from "./ArtistInviteForm"
import { useRequestInvite } from "../../queries/invite.query";
import { useState } from "react";

export const DistributionModal = ({ isOpen, onClose }) => {
    const [inviteSuccess, setInviteSuccess] = useState(false)
    const [successMessage, setSuccessMessage] = useState("")
    const mutateInvite = useRequestInvite()

    const handleInviteSuccess = (message) => {
        setSuccessMessage(message)
        setInviteSuccess(true)
    }

    const handleClose = () => {
        setInviteSuccess(false)
        setSuccessMessage("")
        onClose()
    }
    return (
        <Dialog isOpen={isOpen} hasActiveSubscription={false} onClose={onClose} needSpace={false}>
            <div className="DataAnalyst-page px-4 py-4">
                <div className="container max-w-2xl">
                    <PageDescription
                        title="Distribution"
                        description="Manage your releases, earnings, pitch to playlists, and distribute your music to 479+ platforms through UpNComer Distribution."
                    />
                    <div className="flex flex-col justify-center align-center mt-4 p-4 md:p-8 bg-theme_clr1 rounded-2xl">
                        <Link
                            to={"https://portal.upncomer.co"}
                            target="_blank"
                            className="w-full bg-theme_clr4 text-white text-center px-6 py-3 rounded-xl hover:bg-theme_clr2 transition-colors font-medium mx-auto flex items-center justify-center gap-2"
                        >
                            <img
                                src={DistributionIcon}
                                alt="distribution"
                                style={{ filter: "brightness(0) invert(1)" }}
                                className="h-[20px] w-[20px] min-w-[20px]"
                            />
                            Access Distrbution Portal
                        </Link>
                        {/* Divider */}
                        <div className="relative flex py-4 items-center">
                            <div className="flex-grow border-t border-gray-400"></div>
                            <div className="flex-grow border-t border-gray-400"></div>
                        </div>
                        {/* Secondary Content */}
                        {inviteSuccess ? (
                            <div className="text-white text-center text-sm mb-4">
                                {successMessage}
                                <br/>
                                <button
                                    onClick={handleClose}
                                    className="mt-4 bg-theme_clr4 text-white px-6 py-2 rounded-xl hover:bg-theme_clr2 transition-colors font-medium"
                                >
                                    OK
                                </button>
                            </div>
                        ) : (
                            <>
                                <div className="text-white text-center text-lg font-jakarta">
                                    Don't have an invite yet?
                                </div>
                                <ArtistInviteForm mutateInvite={mutateInvite} onSuccess={handleInviteSuccess} />
                            </>
                        )}
                    </div>
                </div>
            </div>
        </Dialog>
    )
}